<template>
  <div class=""
    v-bind:style="{
      fontFamily: globalFont
    }">
    {{ error_message }}<br />
    <div v-if="error_code && error_message !== ''" class="error-code-container">
      [ERROR {{ error_code }}]
    </div>
  </div>
</template>

<script>
import { Cart } from '@/store/Cart'

export default {
  name: 'OmiseMessages',
  data () {
    return {
      error_message: '',
      error_code: ''
    }
  },
  props: {
    message: {
      type: String,
      default: ''
    },
    locale: {
      type: String,
      default: 'en'
    },
    error: {
      type: String,
      default: ''
    },
  },
  computed: {
    t () {
      if (this.locale == 'en') {
        return {
          authentication_failure: 'Merchant authentication failed',
          bad_request: 'Order failed',
          expired_charge: 'Charge expired',
          failed_capture: 'Charge is not authorized',
          failed_void: 'Void failed',
          invalid_amount: 'Amount must be an integer',
          invalid_bank_account: 'Brand is not included in the list',
          invalid_card: 'Number is invalid and brand not supported (unknown)',
          invalid_card_token: 'Order failed',
          invalid_charge: 'Currency is currently not supported and amount is not a number',
          invalid_filter: 'Invalid filters',
          invalid_link: 'Currency is not currently supported',
          invalid_page: 'Invalid page',
          invalid_scope: 'Invalid scope',
          missing_card: 'Request contains no card parameters',
          not_found: 'Customer card was not found',
          used_token: 'Order failed',
          invalid_security_code: 'The security code was invalid or the card didn\'t pass preauth.',
          payment_rejected: 'The payment was rejected by the issuer or the acquirer with no specific reason.',
          insufficient_fund: 'Insufficient funds in the account or the card has reached the credit limit.',
          stolen_or_lost_card: 'Card is stolen or lost.',
          failed_processing: 'Card processing has failed, you may retry this transaction.',
          failed_fraud_check: 'Card was marked as fraudulent.',
          invalid_account_number: 'This number is not attributed or has been deactivated.',
          less_than_lower_price_omise: 'Total Price is lower than Omise rule. Please order more item.',
          error_occured_try_again: 'Error occured! Please try again later.'
        }
      } else if (this.locale == 'th') {
        return {
          authentication_failure: 'ร้านค้ายืนยันตัวตนไม่สำเร็จ',
          bad_request: 'สั่งซื้อไม่สำเร็จ',
          expired_charge: 'ทำรายการนานเกินไป กรุณาลองใหม่อีกครั้ง',
          failed_capture: 'ไม่สามารถชำระเงินได้',
          failed_void: 'คืนเงินไม่สำเร็จ',
          invalid_amount: 'ราคาต้องเป็นตัวเลข',
          invalid_bank_account: 'ธนาคารนี้ไม่เข้าร่วมรายการ',
          invalid_card: 'หมายเลขบัตรเครดิตไม่ถูกต้อง และ ธนาคารนี้ไม่เข้าร่วมรายการ',
          invalid_card_token: 'สั่งซื้อไม่สำเร็จ',
          invalid_charge: 'ไม่รองรับสกุลเงินนี้ และราคาต้องเป็นตัวเลขเท่านั้น',
          invalid_filter: 'ค้นหาไม่สำเร็จ',
          invalid_link: 'ไม่รองรับสกุลเงินนี้',
          invalid_page: 'ค้นหาไม่สำเร็จ',
          invalid_scope: 'ค้นหาไม่สำเร็จ',
          missing_card: 'ไม่พบข้อมูลบัตรเครดิต',
          not_found: 'ไม่พบข้อมูลบัตรเครดิต',
          used_token: 'สั่งซื้อไม่สำเร็จ',
          invalid_security_code: 'หมายเลข cvc ไม่ถูกต้อง',
          payment_rejected: 'ไม่สามารถชำระเงินได้',
          insufficient_fund: 'วงเงินบัตรไม่เพียงพอ',
          stolen_or_lost_card: 'บัตรถูกขโมยหรือสูญหาย',
          failed_processing: 'ทำรายการไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
          failed_fraud_check: 'บัตรเครดิตถูกปลอมแปลง',
          invalid_account_number: 'ปิดการใช้งานบัตรเครดิต',
          less_than_lower_price_omise: 'ราคารวมสุทธิต่ำกว่าราคาที่ Omise กำหนด กรุณาสั่งซื้อสินค้าเพิ่มเติม',
          error_occured_try_again: 'เกิดข้อผิดพลาด! โปรดลองใหม่ภายหลัง'
        }
      } else if (this.locale == 'vi') {
        return {
          authentication_failure: 'Xác nhận nhà cung cấp không thành công',
          bad_request: 'Đặt hàng thất bại',
          expired_charge: 'Giao dịch hết hạn',
          failed_capture: 'Thanh toán không thành công',
          failed_void: 'Void thất bại',
          invalid_amount: 'Tổng số phải là số nguyên',
          invalid_bank_account: 'Ngân hàng không tồn tại trong danh sách',
          invalid_card: 'Số tài khoản không hợp lệ và ngân hàng này không được hỗ trợ này.',
          invalid_card_token: 'Đặt hàng thất bại',
          invalid_charge: 'Loại tiền tệ này hiện chưa được hỗ trợ và tổng số không hợp lệ.',
          invalid_filter: 'Bộ lọc không hợp lệ',
          invalid_link: 'Loại tiền tệ này hiện chưa được hỗ trợ',
          invalid_page: 'Trang không hợp lệ',
          invalid_scope: 'Phạm vi đánh giá không hợp lệ',
          missing_card: 'Không có tham số thẻ',
          not_found: 'Không tìm thấy thông tin thẻ',
          used_token: 'Đặt hàng thất bại',
          invalid_security_code: 'Mã bào mật không hợp lệ hoặc thẻ không được chấp nhận bởi hệ thống bảo mật.',
          payment_rejected: 'Thanh toán bị từ chối không rõ nguyên do.',
          insufficient_fund: 'Bạn không có đủ tiền trong tài khoản hoặc tài khoản đã chạm mức thanh toán giới hạn.',
          stolen_or_lost_card: 'Thẻ bị mất hoặc đánh cắp.',
          failed_processing: 'Thanh toán thất bại, vui lòng thử lại.',
          failed_fraud_check: 'Thẻ bị đánh dấu gian lận.',
          invalid_account_number: 'Số tài khoản không tồn tại hoặc đã bị tạm dừng.',
          less_than_lower_price_omise: 'Tổng giá trị đơn hàng thấp hơn quy tắc Omise. Vui lòng đặt thêm sản phẩm.',
          error_occured_try_again: 'Xảy ra lỗi! Vui lòng thử lại sau'
        }
      }
    },
    globalFont () {
      return Cart.getGlobalFont()
    }
  },
  created () {
    // Error 01 is authentication failed
    // Error 02 is payment failure
    // Error 03 is other errors

    this.error_code = '02'

    if (this.message === 'authentication_failure') {
      this.error_message = this.t.authentication_failure
    } else if (this.message === 'bad_request') {
      this.error_message = this.t.bad_request
    } else if (this.message === 'expired_charge') {
      this.error_message = this.t.expired_charge
    } else if (this.message === 'failed_capture') {
      this.error_message = this.t.failed_capture
    } else if (this.message === 'failed_void') {
      this.error_message = this.t.failed_void
    } else if (this.message === 'invalid_amount') {
      this.error_message = this.t.invalid_amount
    } else if (this.message === 'invalid_bank_account') {
      this.error_message = this.t.invalid_bank_account
    } else if (this.message === 'invalid_card') {
      this.error_message = this.t.invalid_card
    } else if (this.message === 'invalid_card_token') {
      this.error_message = this.t.invalid_card_token
    } else if (this.message === 'invalid_charge') {
      this.error_message = this.t.invalid_charge
    } else if (this.message === 'invalid_filter') {
      this.error_message = this.t.invalid_filter
    } else if (this.message === 'invalid_link') {
      this.error_message = this.t.invalid_link
    } else if (this.message === 'invalid_page') {
      this.error_message = this.t.invalid_page
    } else if (this.message === 'invalid_scope') {
      this.error_message = this.t.invalid_scope
    } else if (this.message === 'missing_card') {
      this.error_message = this.t.missing_card
    } else if (this.message === 'not_found') {
      this.error_message = this.t.not_found
    } else if (this.message === 'used_token') {
      this.error_message = this.t.used_token
    } else if (this.message === 'payment_rejected') {
      this.error_message = this.t.payment_rejected
    } else if (this.message === 'insufficient_fund') {
      this.error_message = this.t.insufficient_fund
    } else if (this.message === 'stolen_or_lost_card') {
      this.error_message = this.t.stolen_or_lost_card
    } else if (this.message === 'failed_processing') {
      this.error_message = this.t.failed_processing
    } else if (this.message === 'failed_fraud_check') {
      this.error_message = this.t.failed_fraud_check
    } else if (this.message === 'invalid_account_number') {
      this.error_message = this.t.invalid_account_number
    } else if (this.message === 'less_than_lower_price_omise') {
      this.error_message = this.t.less_than_lower_price_omise
    } else {
      if (this.error === '11') {
        this.error_code = false
        this.error_message = this.message
      } else {
        this.error_code = '03'
        if (this.message === Cart.t.discountPriceChanges) {
          this.error_message = this.message
        } else {
          this.error_message = this.t.error_occured_try_again
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.error-code-container {
  text-align: center;
  font-size: 0.6em;
}
</style>


// WEBPACK FOOTER //
// src/components/share/OmiseMessages.vue